export class Manager {
    id: number = 0;
    user: string = "";
    name: string = "";
}
